import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../Section';
import { OneTrustCookieList as OneTrustCookieListComponent } from '../../OneTrustCookieList';

export const OneTrustCookieList = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow'} {...rest}>
    <OneTrustCookieListComponent {...data} />
  </Section>
);
